export default "/images/sonderjysk-cropped.png?46da8f0d646e63e09f71af24be154b7f";